import React from 'react'
import { ReduxProvider } from './redux-provider'
import { useComponentWillMount } from '../react-hooks'

export let wappSystemApi: Record<string, Function> = {}

const Root = ({ children, ...props }: { children: JSX.Element }) => {
  useComponentWillMount(() => {
    // @ts-ignore
    wappSystemApi = props
  })

  return <ReduxProvider>{children}</ReduxProvider>
}

export default Root
